import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import { useServices } from "@core/servicesContext";
import { useUserProfile } from "@domain/user/hooks";
import { Profile } from "@domain/user/profile";
import { useAsync } from "@utils/hooks";
import { LoadingButton } from "@ui/components/buttons/loadingButton";

interface NotificationFollowButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	userId: string;
}
export const NotificationFollowButton: React.FC<NotificationFollowButtonProps> = ({ userId, ...htmlProps }) => {
	const { result: profile } = useUserProfile(userId);

	return profile ? <FollowButtonContent profile={profile} {...htmlProps} /> : null;
};

interface FollowButtonContentProps extends React.HTMLAttributes<HTMLButtonElement> {
	profile: Profile;
}

export const FollowButtonContent: React.FC<FollowButtonContentProps> = ({ profile, ...htmlProps }) => {
	const { userService } = useServices();
	const initialProfile = useMemo(() => profile, []);
	const { run, loading } = useAsync(() => userService.toggleFollow(profile), [profile.id]);

	if (initialProfile.followedByMeSince) {
		return null;
	}

	return profile.followedByMeSince ? (
		<LoadingButton loading={loading} buttonType="default" {...htmlProps} onClick={run}>
			{I18n.t("profile.action.unfollow")}
		</LoadingButton>
	) : (
		<LoadingButton loading={loading} buttonType="secondary" {...htmlProps} onClick={run}>
			{I18n.t("profile.action.follow_back")}
		</LoadingButton>
	);
};
